<p-dialog
  [visible]="visivel"
  (onHide)="onHide()"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [showHeader]="false"
  [style]="{ width: '62rem' }"
  [breakpoints]="{ '960px': '95vw' }"
  styleClass="dialog-wave-redesign pedido-add-item-dialog"
  maskStyleClass="pedido-add-item-mask">

  <!-- Header wave (FORM_UI secao 3): era o 4o e ultimo dialog da tela de
       pedidos que ainda usava o header padrao do PrimeNG. -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-plus-circle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'pedidos.texts.adicionar_item_titulo' | translate }}</h2>
      </div>
    </div>

    <!-- Saída sempre alcançável: o header é `position: sticky`, então este X
         continua na tela por mais alta que a grade fique. O botão do rodapé
         depende de o dialog caber na janela. -->
    <button
      type="button"
      class="dialog-wave-close"
      [attr.aria-label]="'pedidos.botoes.fechar' | translate"
      (click)="onHide()">
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body add-item-body">

    <!-- Chips de categoria -->
    <div class="categorias-chips-container">
      <div class="chips-scroll">
        <!-- Setas: aparecem só no lado que tem categoria escondida -->
        <button
          type="button"
          class="chips-scroll-nav chips-scroll-nav-esquerda"
          [disabled]="!dsCategorias.podeRolarEsquerda"
          [attr.aria-label]="'common.chips_scroll.anterior' | translate"
          (click)="dsCategorias.rolar(-1)">
          <i class="pi pi-chevron-left" aria-hidden="true"></i>
        </button>

        <div
          class="categorias-chips chips-scroll-viewport"
          appDragScroll
          #dsCategorias="appDragScroll"
          [class.tem-esquerda]="dsCategorias.podeRolarEsquerda"
          [class.tem-direita]="dsCategorias.podeRolarDireita">
          <button
            *ngFor="let grupo of grupos"
            class="chip-categoria"
            [class.chip-ativo]="categoriaSelecionada?.id === grupo.id"
            (click)="selecionarCategoria(grupo)">
            <img
              *ngIf="grupo.imagem"
              class="chip-categoria-img"
              [src]="env.imgHost + '/' + idEmpresa + '/grupo/' + grupo.imagem"
              [alt]="grupo.nome"
              (error)="onImageError($event)" />
            <i *ngIf="!grupo.imagem && grupo.id !== null" class="pi pi-th-large chip-categoria-icon"></i>
            <i *ngIf="grupo.id === null" class="pi pi-list chip-categoria-icon"></i>
            <span>{{ grupo.nome }}</span>
          </button>
        </div>

        <button
          type="button"
          class="chips-scroll-nav chips-scroll-nav-direita"
          [disabled]="!dsCategorias.podeRolarDireita"
          [attr.aria-label]="'common.chips_scroll.proximo' | translate"
          (click)="dsCategorias.rolar(1)">
          <i class="pi pi-chevron-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <!-- Busca + checkbox -->
    <div class="search-bar">
      <div class="search-bar-row">
        <div class="search-field-wrapper search-field">
          <p-iconField iconPosition="right">
            <p-inputIcon styleClass="pi pi-search" />
            <input type="text" (input)="onInputChange($event)" (keydown.enter)="onSearchEnter($event)" pInputText
              [placeholder]="'criar_pedido.buscar_ph' | translate" class="w-full" />
          </p-iconField>
        </div>
        <div class="checkbox-sem-saldo">
          <p-checkbox
            inputId="ck-add-sem-saldo"
            [(ngModel)]="mostrarSemSaldo"
            binary="true"
            (onChange)="onToggleSemSaldo()">
          </p-checkbox>
          <label for="ck-add-sem-saldo">{{ 'criar_pedido.mostrar_sem_saldo' | translate }}</label>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="add-item-loading">
      <p-progressSpinner strokeWidth="3" animationDuration="1s"></p-progressSpinner>
    </div>

    <!-- Grid de produtos -->
    <div class="produtos-grid" *ngIf="!loading && !produtoNaoEncontrado">
      <div
        class="produto-item"
        *ngFor="let produto of produtos"
        tabindex="0"
        [class.tem-no-pedido]="quantidadeNoPedido(produto) > 0"
        [pTooltip]="'criar_pedido.adicionar_produto' | translate"
        tooltipPosition="top"
        [class.disabled-card]="!podeClicar(produto)"
        (click)="podeClicar(produto) && adicionarProduto(produto)"
        (keydown.enter)="podeClicar(produto) && adicionarProduto(produto)">

        <div class="produto-img-container">
          <img
            [src]="env.imgHost + '/' + idEmpresa + '/item/' + produto.imagem"
            [alt]="produto.nome"
            [attr.data-product-id]="produto.id"
            (error)="onImageError($event)"
            [class.img-hidden]="temErroImagem(produto)" />
          <svg *ngIf="temErroImagem(produto)"
               class="placeholder-svg" viewBox="0 0 160 90" fill="none"
               xmlns="http://www.w3.org/2000/svg"
               aria-hidden="true">
            <rect width="160" height="90" rx="8" class="placeholder-bg"/>
            <rect x="55" y="25" width="50" height="40" rx="4" class="placeholder-border"
                  stroke-width="2" fill="none"/>
            <path d="M65 55l8-10 6 6 14-16v20H65z" class="placeholder-icon"/>
            <circle cx="72" cy="35" r="4" class="placeholder-icon"/>
          </svg>

          <!-- Badge de quantidade ja no pedido -->
          <span class="badge-qtd-pedido" *ngIf="quantidadeNoPedido(produto) > 0">
            {{ quantidadeNoPedido(produto) }}x
          </span>
        </div>

        <h3 class="produto-nome">{{ produto.nome }}</h3>
        <p class="produto-cod">{{ 'criar_pedido.cod' | translate }} {{ produto.codigoItem }}</p>

        <p class="produto-preco" *ngIf="moedaPadrao === 'PYG'">{{ produto.precoDeVenda | guaraniFormat }}</p>
        <p class="produto-preco" *ngIf="moedaPadrao !== 'PYG'">
          {{ produto.precoDeVenda | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}
        </p>

        <span *ngIf="!indisponivel(produto)" class="badge-estoque badge-disponivel">
          {{ 'criar_pedido.em_estoque' | translate }} {{ produto.saldo | number:'1.0-0' }}
        </span>
        <span *ngIf="indisponivel(produto)" class="badge-estoque badge-indisponivel">
          {{ 'criar_pedido.indisponivel' | translate }}
        </span>
      </div>
    </div>

    <!-- Empty state -->
    <div *ngIf="!loading && produtoNaoEncontrado" class="vm-empty-state">
      <i class="pi pi-box"></i>
      <span>{{ 'criar_pedido.produto_nao_encontrado' | translate }}</span>
    </div>

    <!-- Paginacao -->
    <p-paginator
      *ngIf="!loading && !produtoNaoEncontrado"
      [rows]="tamanhoPagina"
      [totalRecords]="totalElements"
      [first]="paginaAtual * tamanhoPagina"
      [rowsPerPageOptions]="[12, 24, 48]"
      (onPageChange)="onPaginatorChange($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} de {totalRecords}">
    </p-paginator>
  </div>

  <!-- Com [closable]=false o X do PrimeNG some e o Escape para de fechar, então
       este botão é a saída explícita. A segunda saída é o botão
       .dialog-wave-close do header sticky, que continua visível mesmo quando a
       grade paginada empurra este rodapé para fora da tela. -->
  <ng-template pTemplate="footer">
    <button pButton
            type="button"
            [label]="'pedidos.botoes.fechar' | translate"
            class="p-button-secondary"
            (click)="onHide()">
    </button>
  </ng-template>
</p-dialog>
